import z, { type ZodType } from 'zod'

export function apiOk<T extends ZodType>(schema: T) {
  return z.object({
    code: z.string().or(z.number()).default('200'),
    msg: z.string().default('Ok'),
    data: schema,
  })
}
